/**
 * UI element: modals
 * requires: jquery, bootstrap
 */

(function(root) {
    /**
     * Modal object
     * @param {Object} config all of the config properties are optional, but you at least need to set config.content or config.url
     * @param {String} [config.id=s-sui-modal] optional modal ID (you only need this for opening multiple modals at the same time)
     * @param {String} [config.title] text for header of modal (if absent header will not be displayed)
     * @param {String|HTMLElement} [config.content] html content for modal (inserted into .modal-body) Accepts html string or whole element. (alternately use config.url to load content)
     * @param {String} [config.url] content will be loaded into .modal-content from this url if present (format returned data as json object with properties: title, content, buttons (same as config.title, config.content, and config.buttons)
     * @param {Bool} [config.fade] should the modal use the "fade in/out" effect
     * @param {Function} [config.callback] a function called when the modal is shown, the modal object is passed as the first parameter.
     * @param {Function} [config.closeCallback] a function called when the modal is closed, the modal object is passed as the first parameter.
     * @param {Boolean} [config.footer=false] display footer (buttons) or not, overridden if you set config.buttons
     * @param {String} [config.size] only accepts 'large' to apply the modal-lg class (wider modal than normal)
     * @param {Object[]} [config.buttons] button settings for use in footer
     * @param {Object} [config.buttons[]]
     * @param {String} [config.buttons[].bclass] class(es) to add to the button (like btn-primary) defaults to btn-default
     * @param {String} [config.buttons[].label] text of the button
     * @param {Function} [config.buttons[].callback] callback applied when button is clicked, the modal object will be found in e.data.modal of the click event
     * @param {Boolean} [config.returnfocus=true] return focus to the element that was active when the modal opened (usually that should be the button that triggered the modal)
     * @param {Boolean|String} [config.backdrop=true] Bootstrap modal backdrop option (only string option is "static")
     * @param {Boolean} [config.keyboard=true] Bootstrap modal keyboard option
     * @param (Object) [config.textTrans] Translatated text for default button and message text.
     */
    var modal = function(config) {
        if (typeof config === 'undefined') {
            config = {};
        }

        /**
         * (re)set the config properties (used on instantiation and in this.redraw())
         * @param {Object} config same as above
         */
        this.setConfig = function(config) {
            this.id = (config.id) ? config.id : 's-sui-modal';
            this.title = (config.title) ? config.title : '';
            this.content = (config.content) ? config.content : '';
            this.url = (config.url) ? config.url : null;
            this.fade = (config.fade) ? true : false;
            this.callback = (config.callback) ? config.callback : null;
            this.closeCallback = (config.closeCallback) ? config.closeCallback : null;
            this.footer = (config.footer === true) ? config.footer : false;
            this.size = (config.size) ? config.size : '';
            this.modal_buttons = (config.buttons) ? config.buttons : [];
            this.returnfocus = (config.returnfocus === false) ? false : true;
            this.opener = document.activeElement;
            this.btn_callbacks = {};
            this.backdrop = (typeof config.backdrop === 'undefined')
                ? true
                : (config.backdrop === 'static' ? 'static' : !!config.backdrop);
            this.keyboard = (config.keyboard === false) ? false : true;
            var transDefined = (typeof config.transText !== 'undefined');
            this.transText = {
                close: (transDefined && config.transText.close) ? config.transText.close : 'Close',
                error: (transDefined && config.transText.error) ? config.transText.error : 'Error',
                unknown: (transDefined && config.transText.unknown) ? config.transText.unknown : 'Unknown',
                invalidResponse: (transDefined && config.transText.invalidResponse) ? config.transText.invalidResponse : 'Invalid response received',
                toggle:(transDefined && config.transText.toggle) ? config.transText.toggle : 'Toggle Dropdown'
            };
        };

        this.setConfig(config);

        /**
         * Create the div if necessary and add it to the body
         */
        this.$el = jQuery('#' + this.id);
        if (jQuery('#' + this.id).length === 0) {
            this.$el = jQuery('<div class="modal ' + (this.fade ? 'fade' : '') + '" tabindex="-1" role="dialog" aria-labelledby="s-sui-modal-header"></div>')
                .attr('id', this.id)
                .html('<div class="modal-dialog"><div class="modal-content"></div></div>');
            /**
             * Put modal at top of page so there is something to focus on when tabbing out of modal (allowing us to then focus back on the modal)
             */
            if (this.id === 's-sui-modal') {
                jQuery('body').prepend( this.$el );
            } else {
                //put non-default modals AFTER any other modals
                var modals = jQuery('div.modal');
                if (modals.length > 0) {
                    modals.filter(':last').after( this.$el );
                } else {
                    jQuery('body').prepend( this.$el );
                }
            }
        }

        if (this.size === 'large') {
            this.$el.find('.modal-dialog').addClass('modal-lg');
        }

        /**
         * Callback: Modal content retrieval.
         * @param {Object} data Response payload.
         */
        this.retrieveSuccess = function(data) {
            if (data.title) {
                this.title = data.title;
            }
            if (data.content) {
                this.content = data.content;
            }
            if (data.buttons) {
                this.modal_buttons = data.buttons;
            }
            this.footer = (data.footer && data.footer === true) ? true : false;

            this.draw();
        };
        /**
         * Callback: Modal content retrieval. Failed.
         * @param {Object} jqXhr JQuery response object.
         */
        this.retrieveFail = function(jqXhr) {
            var error = this.transText.unknown;
            if (jqXhr.responseText) {
                try {
                    var response = JSON.parse(jqXhr.responseText);
                    if (response.error) {
                        error = response.error;
                    }
                } catch (e) {
                    error = this.transText.invalidResponse;
                }
            }
            this.content = this.transText.error + ': ' + error;
            this.footer = true;
            this.draw();
        };

        /**
         * retrieve content
         */
        this.retrieve = function() {
            jQuery.ajax({
                url: this.url,
                cache: false,
                method: 'GET',
                dataType: 'json'
            })
                .done(this.retrieveSuccess.bind(this))
                .fail(this.retrieveFail.bind(this));
        };
        /**
         * Handler: Bootstrap modal show event.
         */
        this.handleShowEvent = function() {
            if (this.callback !== null) {
                this.callback(this);
            }
        };
        /**
         * Handler: Bootstrap modal hide event.
         */
        this.handleHideEvent = function() {
            // return focus to opener (button/link)
            if (this.returnfocus && typeof this.opener !== 'undefined' && this.opener !== null) {
                this.opener.focus();
            }

            // call close callback with modal as first argument.
            if (this.closeCallback !== null) {
                this.closeCallback(this);
            }
            // clean up events and html (for DOM element reuse)
            this.$el.off().removeData('bs.modal').find('.modal-content').html('');
            jQuery('#' + this.id + ' .modal-dialog').removeClass('modal-lg');
            // make sure callbacks are cleared, else they can end up firing multiple times.
            this.callback = null;
            this.closeCallback = null;
        };
        /**
         * Format the modal content and apply appropriate callbacks and handlers and such
         * this will also show the modal
         */
        this.draw = function() {
            //@todo might be better if we used a template (then you could even pass in the template if you wanted)
            var template = '<div class="modal-content">';
            if (this.title !== '') {
                template += '<div class="modal-header"><button id="s-sui-modal-close" type="button" class="close" data-dismiss="modal" aria-label="&times; ' + this.transText.close + '">&times;</button><h2 class="modal-title" id="s-sui-modal-header">' + this.title + '</h2></div>';
            }
            var contentHtml = '';
            if (typeof this.content === 'string') {
                contentHtml = this.content;
            }
            template += '<div class="modal-body">' + contentHtml + '</div>';
            if (this.footer || this.modal_buttons.length > 0) {
                this.btn_callbacks = {}; //reset here just in case
                template += '<div class="modal-footer">';
                if (this.modal_buttons.length === 0) {
                    template += '<button type="button" class="btn btn-default" data-dismiss="modal">' + this.transText.close + '</button>';
                } else {
                    this.modal_buttons.forEach(function(v, k) {
                        if (v.links && v.links.length > 0) {
                            // Button dropdown
                            v.gclass = v.gclass ? v.gclass : '';
                            template += '<div class="btn-group ' + v.gclass + '">';

                            // Main button of the group
                            v.bclass = (v.bclass) ? v.bclass : 'btn-default';
                            v.label = (v.label) ? v.label : '';
                            if (v.label !== '') {
                                template += '<button type="button" class="btn ' + v.bclass + ' btn-modal-' + k + '" >' + v.label + '</button>';
                                if (v.callback) {
                                    this.btn_callbacks['btn-modal-' + k] = v.callback;
                                }
                            }

                            template += '<button type="button" class="btn ' + v.bclass + ' dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="caret"></span><span class="sr-only">' + this.transText.toggle + '</span></button>';
                            template += '<ul class="dropdown-menu">';

                            v.links.forEach(function(x, y) {
                                x.label = (x.label) ? x.label : '';
                                if (x.label !== '') {
                                    var href = (x.url) ? x.url : '#';
                                    template += '<li><a href="' + href + '" class="link-modal-' + y + '">' + x.label + '</a></li>';
                                    if (x.callback) {
                                        this.btn_callbacks['link-modal-' + y] = x.callback;
                                    }
                                }
                            }, this);

                            template += '</ul>';
                            template += '</div>';
                        } else {
                            // Normal button
                            v.bclass = (v.bclass) ? v.bclass : 'btn-default';
                            v.label = (v.label) ? v.label : '';
                            if (v.label !== '') {
                                template += '<button type="button" class="btn ' + v.bclass + ' btn-modal-' + k + '" >' + v.label + '</button>';
                                if (v.callback) {
                                    this.btn_callbacks['btn-modal-' + k] = v.callback;
                                }
                            }
                        }
                    }, this);
                }
                template += '</div>';
            }
            template += '</div>';

            var html = jQuery(template);
            // if this.content is a HTMLElement we need to append it
            // this let's us keep any events on the content.
            if (typeof this.content !== 'string') {
                html.find('.modal-body').html(this.content);
            }

            this.$el.find('.modal-content').replaceWith(html);

            /**
             * Apply button callbacks
             */
            if (this.modal_buttons.length > 0) {
                for (var b in this.btn_callbacks) {
                    if (this.btn_callbacks.hasOwnProperty(b)) {
                        if (typeof this.btn_callbacks[b] === 'function' ) {
                            this.$el.find('.' + b).on('click', { modal: this }, this.btn_callbacks[b]);
                        }
                    }
                }
            }

            /**
             * Apply any callbacks to the show event (this happens before the viewer sees the modal
             */
            this.$el.on('show.bs.modal', this.handleShowEvent.bind(this));

            /**
             * show the modal
             */
            this.$el.modal({ backdrop: this.backdrop, keyboard: this.keyboard }, 'show');

            /**
             * clean up modal on close, making sure to empty the html and unbind events
             */
            this.$el.on('hidden.bs.modal', this.handleHideEvent.bind(this));
        };
        /**
         * Close the modal, which triggers the hidden.bs.modal event handler above
         */
        this.close = function() {
            jQuery('#' + this.id).modal('hide');
        };
        /**
         * Change the content/workings of an existing/open modal
         * @param {Object} newConfig Reconfig a new config option, any included properties will overwrite the current object properties
         */
        this.redraw = function(newConfig) {
            //unbind the show/hide handlers we create in this.draw()
            this.$el.unbind('show.bs.modal').unbind('hidden.bs.modal');
            //reconfig
            this.setConfig(newConfig);

            if (this.url !== null) {
                this.retrieve();
            } else {
                this.draw();
            }
        };


        /**
         * The action starts here
         */
        if (this.url !== null) {
            this.retrieve();
        } else {
            this.draw();
        }
    };

    // support export as module (like in node)
    // or else just attach to the window.springSpace object
    if (typeof module !== 'undefined') {
        module.exports = modal;
    } else {
        root.springSpace = root.springSpace || {};
        root.springSpace.sui = root.springSpace.sui || {};
        root.springSpace.sui.modal = root.springSpace.sui.modal || modal;
    }

})(this);

/*
    Example usage:

    Basic modal with title and content already available
    var modal = new springSpace.sui.modal({ title: 'A Modal', content: '<p>Hello, modal.</p>' });

    Basic modal with callback (this in the callback will refer to the modal object)
    var modal = new springSpace.sui.modal({ title: 'A Modal', content: '<p>Hello, modal.</p>', callback: function(){ this.$el.find('p').css('color', 'pink'); } });

    Basic ajax loaded modal
    var modal = new springSpace.sui.modal({ url: '/process_public.php?m=qform' });

    On the server side, the ajax request should return a JSON encoded object with:
    title (optional, title of modal)
    content (html content of modal)
    footer (boolean, defaults to false, just show a basic footer with a close button)
    buttons (array of buttons for footer of modal, as an alternate to the footer boolean)
        -each button is an assoc array (or object) with: label, bclass (optional), links (optional), and gclass (optional class for button group div if links is set).
        -Use the links property to create a button dropdown. Links is an array of objects with: label, callback (optional), and url (optional, defaults to '#')

    Ajax with callback (first argument to the callback will refer to the modal object)
    var modal = new springSpace.sui.modal({ url: '/process_public.php?m=qform', callback: function(modal){ console.log(modal); } });

    Button callbacks are passed the modal object in e.data
    var modal = new springSpace.sui.modal({ title: 'A Modal', content: '<p>Hello, modal.</p>', footer: true, buttons: [{bclass: 'btn-primary btn-lg', label:'test close', callback: function(e){ e.data.modal.close(); } }] });

    Close the modal manually:
    modal.close();
    (You can also use the normal data-dismiss="modal" attribute on buttons, that will still trigger an event handler to clean-up the modal)

    Trigger function on close:
    config.closeCallback = function(modal) {
        // do something here.
    };
    // most likely you'll want to bind the function to another object for anything complicated.

    Replace the modal content without closing/reopening it:
    modal.redraw({ title: 'New modal title', content: '<p>This is all new content</p>' });
    modal.redraw({ url: '/process_public.php?m=qform' });

    Custom "confirm" modal
    var confirm = new springSpace.sui.modal({
        content: 'Are you sure you want to proceed?',
        buttons: [
            { label: 'No', callback: function(e){ e.data.modal.close(); } },
            { label: 'Yes', bclass: 'btn-primary', callback: function(e){ doSomething(); e.data.modal.close(); } }
        ]
    });

    Translate default modal button/message text into other languages:
    Set config.transText to an object with the following fields
        close (text that displays on default button to close the modal window - Default value is "Close")
        error (default text preceeding error message for failed callback - Default value is "Error")
        unknown (default error text for a failed callback - Default value is "Unknown")
        invalidResponse (default error text for invalid response for a failed callback - Default is "Invalid response received")
        toggle (default screen reader text for dropdown puttons - Default is "Toggle Dropdown")
    Example translating to French:
    var modal = new springSpace.sui.modal({
        transText: {
            close: 'Fermer',
            error: 'Erreur',
            unknown: 'Inconnu',
            invalidResponse: 'Réponse\u0020invalide.',
            toggle: 'Basculer\u0020la\u0020liste\u0020déroulante'
        }
    });

*/
